import { type IThemeContext } from '@/state/Theme';

import Logo from './components/icons/Logo';
import LogoMobile from './components/icons/LogoMobile';
import commonColors from '@/state/CommonColors';

const brandTheme: IThemeContext = {
  brandLogo: Logo,
  brandLogoMobile: LogoMobile,
  brandColor: '#014B60',
  brandName: 'Caltex',
  footerIconColor: '#ffffff',
  brandStationLabelMobile: 'Service station / Truck stop',
  brandStationLabelDesktop:
    'Please enter a Location / Service station / Truck stop',
  colorPalette: [
    // Common colours shared between brands
    ...commonColors,

    // Brand colours specific to Caltex
    { name: 'deep-ocean-blue', value: '#014B60' },
    { name: 'primary-red', value: '#FE0C00' },
    { name: 'primary-red-active', value: '#C31E33' },
    { name: 'accessible-red', value: '#E42E45' },
    { name: 'light-blue', value: '#E5EDF0' },
    { name: 'mid-blue', value: '#457489' },
    { name: 'sec-grey', value: '#737579' },
    { name: 'light-grey', value: '#C6C6C6' },
    { name: 'indigo', value: '#1E196A' },
  ],
  colorApplication: {
    bannerLinkGridBackground: '#e5edf0',
    bannerLinkGridColor: '#014b60',
  },
};

export default brandTheme;
